export const AVAILY_API_URLS = {
  CLIENT_STAGING: 'https://dev-core-app.dental21.de/api/availy',
  CLIENT_PRODUCTION: 'https://core-app.dental21.de/api/availy',
  PUBLIC_CLIENT_STAGING: 'https://dev-core-app.dental21.de/api/v1/public',
  PUBLIC_CLIENT_PRODUCTION: 'https://core-app.dental21.de/api/v1/public',
}

export const GAP_FILLER_URLS = {
  STAGING: 'https://staging-gap-filler-backend.dental21.de/public',
  PRODUCTION: 'https://gap-filler-backend.dental21.de/public',
}

export const CLINIC_SERVICE_URLS = {
  STAGING: 'https://staging-clinic-resource-backend.dental21.de/api/v1/public',
  PRODUCTION: 'https://clinic-resource-backend.dental21.de/api/v1/public',
}

export const MEDPRESS_API_URLS = {
  STAGING: 'https://staging-medpress.dental21.de/api',
  PRODUCTION: 'https://medpress.dental21.de/api',
}

export const AVAILY_SCRIPT_URLS = {
  STAGING: 'https://availy.dental21.cloud',
  PRODUCTION: 'https://availy.dental21.de',
}

export const AVAILY_STATIC_URLS = {
  JS: '/static/js/availy.min.js',
  CSS: '/static/css/main.styles.css',
}
